export const CRM_CONFIG = {
  BASE_URL_READ: 'https://api-crm.kingcrm.com.br/api',
  BASE_URL_WRITE: 'https://api-crm.kingcrm.com.br/api',
  TOKEN: 'RVVBVVRPUklaT1ZPQ0VNRVVBTUlHTw==',
  FUNIL_ID: 63
} as const;

export const APP_CONFIG = {
  BASE_URL: 'https://franqueabilidade.inovafranquias.com.br',
  COMPANY_NAME: 'Inova Franquias',
  DIAGNOSTIC_TITLE: 'Diagnóstico Resumido',
  PDF_OUTPUT_DIR: '/diagnosticos',
  LOGO_PATH: '/assets/inova-hub-franquias.png'
} as const;

export const SCORING_WEIGHTS = {
  credibilidade_marca: 40,
  modelo_negocio_padronizacao: 10,
  perfil_franqueador: 20,
  diferenciais_competitivos: 10,
  capacidade_expansao: 20,
  registro_marca: 10,
  indicadores_financeiros: 0
} as const;

export const STATUS_THRESHOLDS = {
  OK: 70,
  ATTENTION: 40
} as const;

export const CATEGORY_LABELS: Record<string, string> = {
  credibilidade_marca: 'Credibilidade da Marca',
  modelo_negocio_padronizacao: 'Modelo de Negócio e Padronização',
  perfil_franqueador: 'Perfil do Franqueador',
  diferenciais_competitivos: 'Diferenciais Competitivos',
  capacidade_expansao: 'Capacidade de Expansão',
  registro_marca: 'Registro de Marca',
  indicadores_financeiros: 'Indicadores Financeiros'
};

export const AFTER_INOVA_IMPROVEMENTS: Record<string, number> = {
  credibilidade_marca: 0.95,
  modelo_negocio_padronizacao: 1.0,
  perfil_franqueador: 0.9,
  diferenciais_competitivos: 0.85,
  capacidade_expansao: 0.95,
  registro_marca: 1.0
};
